import { render, staticRenderFns } from "./IconPushpinOff.vue?vue&type=template&id=512b348c"
import script from "./IconPushpinOff.vue?vue&type=script&lang=js"
export * from "./IconPushpinOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports